<template>
  <div class="container">
    <div class="row bg-info rounded" v-if="msg">
      <div class="col text-center fw-bold">{{ msg }}</div>
    </div>
    <ul class="list-group">
      <li class="list-group-item" v-for="p in sorted_pools" :key="p">
        <div class="row" v-if="edit_this != p.id">
          <div class="col text-center">{{ p.sort }}</div>
          <div class="col border rounded" @click="editThisPool(p.id)">
            {{ p.name }}
          </div>
          <div class="col text-start">Size: {{ p.count }}</div>
          <div class="col d-flex justify-content-between">
            Players: {{ getPlayersInPool(p.id) }}
            <ListCount :pool_id="p.id"></ListCount>
          </div>
          <div class="col">Condition: {{ p.count_condition }}</div>
          <div class="col-3">
            <GenerateList
              :pool_id="p.id"
              @poollist-generated="fetchPools()"
            ></GenerateList>
          </div>
        </div>
        <div class="row" v-if="edit_this == p.id">
          <i class="bi bi-x-lg text-danger" @click="editThisPool(p.id)"></i>
          <EditPool :pool="p" @pool-updated="updateMsg()"></EditPool>
        </div>
      </li>
    </ul>
  </div>
</template>
<script setup>
import { onMounted, ref, computed, onBeforeMount } from "vue";
import EditPool from "./EditPool.vue";
import GenerateList from "../lists/GenerateList.vue";
import ListCount from "../lists/ListCount.vue";
import { useStore } from "@/store/index";
import supabase from "@/supabase/config";
const all_pools = ref([]);
const players_list = ref([]);
const players_in_pool_list = ref([]);
const store = useStore();
const msg = ref("");
const edit_this = ref("");
const editThisPool = (id) => {
  if (edit_this.value != id) {
    edit_this.value = id;
  } else {
    edit_this.value = "";
  }
};
onBeforeMount(() => {
  fetchPlayers();
});
onMounted(() => {
  fetchPools();
});
const fetchPools = async () => {
  let { data: pools, error } = await supabase
    .from("pools")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_pools.value = pools;
};

const updateMsg = () => {
  msg.value = "Pool updated!";
  editThisPool("");
  fetchPools();
  setTimeout(() => {
    msg.value = "";
  }, 2000);
};
const fetchPlayers = async (pool_id) => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("auction_id", store.live_auction);
  players_list.value = players;
};
const sorted_pools = computed(() => {
  var arr = [];
  all_pools.value.forEach((p) => {
    arr.push(p);
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => a.sort - b.sort);
  return sorted_arr;
});
const getPlayersInPool = (pool_id) => {
  var count = 0;
  players_list.value.forEach((p) => {
    if (p.pool_id == pool_id) {
      count++;
    }
  });
  return count;
};
</script>
